import { render, staticRenderFns } from "./InspectionsRecordsTable.vue.html?vue&type=template&id=761fe2ec&scoped=true&external"
import script from "./InspectionsRecordsTable.vue.js?vue&type=script&lang=js&external"
export * from "./InspectionsRecordsTable.vue.js?vue&type=script&lang=js&external"
import style0 from "./InspectionsRecordsTable.vue.scss?vue&type=style&index=0&id=761fe2ec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fe2ec",
  null
  
)

export default component.exports